{
  "es": {
    "message": {
      "actions": {
        "delete_message": "Eliminar mensaje",
        "move_selected": "Mover mensajes seleccionados",
        "send": "Enviar"
      },
      "labels": {
        "already_replied": "ya tiene una respuesta",
        "cannot_delete_message": "Este mensaje ya lo ha leído el cliente, así que no se puede eliminar.",
        "changes_not_saved": "Tienes cambios sin guardar. ¿Seguro que quieres continuar?\np.d.: puedes abrir una pestaña nueva para navegar por otras páginas al mismo tiempo.",
        "delete_message": "Esto elimina el mensaje para todos. Ten en cuenta que puede que ya se haya enviado una notificación por correo, según la configuración del destinatario.",
        "delete_message_abort": "El mensaje no se puede eliminar",
        "move_customer_notification": "Se notificará al cliente cuando el mensaje se traslade a otra conversación",
        "move_to": "Mover mensaje a...",
        "moved_here": "aquí desde la conversación",
        "moved_message": "movió este mensaje",
        "moving_message": "Moviendo mensaje",
        "notSeenYet": "Aún no visto",
        "seen": "Visto por todos",
        "seen_by": "Visto por {participants}",
        "to": "a",
        "you": "ti"
      },
      "validation": {
        "message_required": "El mensaje es obligatorio"
      }
    }
  }
}
